import React, { Component } from 'react'
import { Project, Subcategory } from 'types'
import { Grid, Col, Row, Modal } from 'react-bootstrap'
import Button from 'components/CustomButton/CustomButton'
import { __, T } from 'config/i18n'
import FormInputs, { CustomFormControlProps } from 'components/FormInputs/FormInputs'
import TableView from 'views/common/TableView'
import { Macros, Medias } from 'api'
import { Macro } from 'types'
import { FormGroup } from '@material-ui/core'
import { Checkbox, View, UploadImageBox } from 'components/Common'
import { normalizeMedia } from 'utils'

interface Props {
  project: Project
  refreshCallback: () => void
}
interface State {
  showModal: boolean
  macro: Partial<Macro>
  showImageModal: boolean
}

class MacroTable extends TableView {
  title = __(T.title.macro)
  resource = new Macros()
  columns = [{ label: __(T.form.title), name: 'title' }]
  defaultColumns = [this.imageableColumn, this.editableColumn, this.deletableColumn]
}

export default class ProjectMacroTab extends Component<Props, State> {
  macroResource = new Macros()
  state: State = {
    showModal: false,
    macro: {},
    showImageModal: false,
  }

  properties: CustomFormControlProps[] = [
    {
      label: 'id',
      disabled: true,
    },
    {
      label: 'title',
      required: true,
    },
  ]

  onDetailClick = (item?: Macro) => {
    this.setState({ macro: item || {} })
    this.handleShow()
  }

  onImageableClick = (item?: Macro) => {
    this.setState({ macro: item || {}, showImageModal: true })
  }

  handleClose = () => this.setState({ showModal: false })
  handleShow = () => this.setState({ showModal: true })

  saveClose = async () => {
    const { refreshCallback, project } = this.props
    const { macro } = this.state

    if (!macro) return
    let res
    macro.subcategories = project.subcategories.filter(category => category.macro_id === macro.id).map(x => x.id!)
    if (macro.id) {
      res = await this.macroResource.edit(macro.id, macro)
    } else {
      macro.project_id = project.id!
      res = await this.macroResource.save(macro)
    }
    if (res.success) {
      await this.setState({ showModal: false })
      await refreshCallback()
    }
  }

  onCheckPress = (index: number) => {
    const { project } = this.props
    const { macro } = this.state
    if (project.subcategories[index].macro_id === macro.id) {
      project.subcategories[index].macro_id = undefined
    } else {
      project.subcategories[index].macro_id = macro.id
    }
    this.forceUpdate()
  }

  onSubClick = (subSelected: Subcategory) => {
    const { project } = this.props
    const { macro } = this.state

    let subcategory = project.subcategories.find(x => x.id === subSelected.id)!

    if (subcategory.macro_id === macro.id) {
      subcategory.macro_id = subcategory.old_macro_id
    } else {
      subcategory.old_macro_id = subcategory.macro_id
      subcategory.macro_id = macro.id
    }
    this.forceUpdate()
  }

  onMediaSave = async () => {
    const { project } = this.props
    const { macro } = this.state
    let promises = macro.media
      ?.filter(m => m.media && typeof m.media !== 'string')
      .map(async x => {
        x.id = (await Medias.upload(project.id!, x)).id
      })
    promises && (await Promise.all(promises))

    this.setState({ showImageModal: false })
  }

  render() {
    const { project, refreshCallback } = this.props
    const { showModal, macro, showImageModal } = this.state

    const editModal = (
      <Modal {...(this.props as any)} show={showModal} dialogClassName={'full-modal'} onHide={this.handleClose}>
        <form
          onSubmit={e => {
            e.preventDefault()
            this.saveClose()
          }}
        >
          <Modal.Header closeButton onClick={this.handleClose}>
            <Modal.Title id="contained-modal-title-lg">
              {__(T.title.macro)} {macro.title ? `"${macro.title}"` : ''}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid fluid>
              <Row>
                <Col md={6}>
                  <FormInputs
                    data={macro}
                    ncols={[...this.properties!.map(p => p.ncols || 'col-md-12')]}
                    properties={this.properties}
                  />
                </Col>

                <Col md={6}>
                  {macro.id && (
                    <FormGroup>
                      {__(T.title.subcategories)}
                      {project.subcategories.map((sub, index) => (
                        <Checkbox
                          key={index}
                          title={sub.title}
                          checked={sub.macro_id === macro.id}
                          onClick={() => this.onSubClick(sub)}
                        />
                      ))}
                    </FormGroup>
                  )}
                </Col>
              </Row>
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="warning" fill onClick={this.handleClose}>
              Chiudi
            </Button>
            <Button bsStyle="info" fill type={'submit'}>
              Salva
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    )

    const imageModal = macro.media ? (
      <Modal
        dialogClassName="custom-dialog"
        show={showImageModal}
        onHide={() => this.setState({ showImageModal: false })}
      >
        <Modal.Body>
          <UploadImageBox fileType={'jpg'} medias={normalizeMedia(macro, 'macro', ['main', 'vetrina']).media} />
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="warning" fill onClick={() => this.setState({ showImageModal: false })}>
            Chiudi
          </Button>
          <Button bsStyle="info" fill type={'submit'} onClick={this.onMediaSave}>
            Salva
          </Button>
        </Modal.Footer>
      </Modal>
    ) : (
        <View></View>
      )

    return (
      <>
        <MacroTable
          data={project.macro}
          onDetailClick={this.onDetailClick}
          title={`${__(T.title.macro)} (${project.macro.length})`}
          onImageableClick={this.onImageableClick}
          refreshCallback={refreshCallback}
          {...(this.props as any)}
        />
        {editModal}
        {imageModal}
      </>
    )
  }
}
